export default __webpack_public_path__ + "static/media/Picomto.e3858a53.png";